/**
 * @description IT设备管理 ITDevice
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const ITDeviceBiz = new Logic()

ITDeviceBiz.getDevice = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDevice.getDevice,
    data: data
  })
}

ITDeviceBiz.deleteDevice = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDevice.deleteDevice,
    data: data
  })
}

ITDeviceBiz.changeDevice = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDevice.changeDevice,
    data: data
  })
}

ITDeviceBiz.addDevice = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDevice.addDevice,
    data: data
  })
}

ITDeviceBiz.getDeviceIP = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDevice.getDeviceIP,
    data: data
  })
}

ITDeviceBiz.getPassword = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDevice.getPassword,
    data: data
  })
}

ITDeviceBiz.getITPortStatus = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDevice.getITPortStatus,
    data: data
  })
}

export default ITDeviceBiz
